import type { ShiftGeneratorResult } from '@api/ShiftGeneratorResultService';
import { useShiftGeneratorResultEntry } from '@stores/shiftGeneratorResultStore';
import { useParams } from 'react-router';

const useShiftGeneratorResult = (): {
    shiftGeneratorResult: ShiftGeneratorResult | undefined;
    departmentId: string | undefined;
    taskId: string | undefined;
    isLoadingShiftGeneratorResult: boolean;
} => {
    const { departmentId, taskId } = useParams<{
        departmentId: string;
        taskId: string;
    }>();

    const {
        response: shiftGeneratorResult,
        isLoading: isLoadingShiftGeneratorResult,
    } = useShiftGeneratorResultEntry(departmentId, taskId);

    return {
        shiftGeneratorResult,
        departmentId,
        taskId,
        isLoadingShiftGeneratorResult,
    };
};

export default useShiftGeneratorResult;
